import React from 'react';
import styles from './Analytics.module.css';

const Analytics: React.FC = () => {
  const mockData = {
    totalSales: 12345678,
    totalOrders: 567,
    totalUsers: 1234,
    monthlyGrowth: 15.5,
    topProducts: [
      { name: '메모리 드로어', sales: 89, revenue: 2651100 },
      { name: '메모리 드로어 프리미엄', sales: 45, revenue: 1795500 },
      { name: '메모리 드로어 미니', sales: 23, revenue: 457700 },
    ]
  };

  return (
    <div className={styles.adminAnalytics}>
      <h1>통계 및 분석</h1>
      
      <div className={styles.analyticsOverview}>
        <div className={styles.overviewCard}>
          <h3>총 매출</h3>
          <p className={styles.overviewNumber}>₩{mockData.totalSales.toLocaleString()}</p>
          <span className={styles.growthPositive}>+{mockData.monthlyGrowth}%</span>
        </div>
        <div className={styles.overviewCard}>
          <h3>총 주문</h3>
          <p className={styles.overviewNumber}>{mockData.totalOrders.toLocaleString()}</p>
          <span className={styles.growthPositive}>+12.3%</span>
        </div>
        <div className={styles.overviewCard}>
          <h3>총 사용자</h3>
          <p className={styles.overviewNumber}>{mockData.totalUsers.toLocaleString()}</p>
          <span className={styles.growthPositive}>+8.7%</span>
        </div>
      </div>

      <div className={styles.analyticsCharts}>
        <div className={styles.chartContainer}>
          <h3>인기 상품</h3>
          <div className={styles.productChart}>
            {mockData.topProducts.map((product, index) => (
              <div key={index} className={styles.productBar}>
                <div className={styles.productInfo}>
                  <span className={styles.productName}>{product.name}</span>
                  <span className={styles.productSales}>{product.sales}개</span>
                </div>
                <div className={styles.barContainer}>
                  <div 
                    className={styles.barFill} 
                    style={{ 
                      width: `${(product.sales / mockData.topProducts[0].sales) * 100}%` 
                    }}
                  ></div>
                </div>
                <span className={styles.productRevenue}>₩{product.revenue.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
